import { combineReducers } from 'redux';
import search from './search';
import query from './query';
import ui from './ui';

const nullReducer = state => ({ ...state });

export default combineReducers({
  paths: nullReducer,
  query,
  search,
  static: nullReducer,
  ui
});
